// Service für Kunden-API Calls
import { apiClient } from './api';
import { Kunde, KundeCreateRequest, KundeUpdateRequest, KundenPageResponse } from '../types/kunde';

export class KundenService {
  private static readonly ENDPOINT = '/kunden';

  // Alle Kunden abrufen (mit Pagination)
  static async getAlleKunden(
    page: number = 0,
    size: number = 20,
    sortBy: string = 'id',
    sortDir: string = 'asc'
  ): Promise<KundenPageResponse> {
    const response = await apiClient.get<KundenPageResponse>(this.ENDPOINT, {
      params: { page, size, sortBy, sortDir }
    });
    return response.data;
  }

  // Einzelnen Kunden abrufen
  static async getKundeById(id: number): Promise<Kunde> {
    const response = await apiClient.get<Kunde>(`${this.ENDPOINT}/${id}`);
    return response.data;
  }

  // Neuen Kunden erstellen
  static async createKunde(kunde: KundeCreateRequest): Promise<Kunde> {
    const response = await apiClient.post<Kunde>(this.ENDPOINT, kunde);
    return response.data;
  }

  // Kunden aktualisieren
  static async updateKunde(id: number, kunde: KundeUpdateRequest): Promise<Kunde> {
    const response = await apiClient.put<Kunde>(`${this.ENDPOINT}/${id}`, kunde);
    return response.data;
  }

  // Kunden löschen
  static async deleteKunde(id: number): Promise<void> {
    await apiClient.delete(`${this.ENDPOINT}/${id}`);
  }

  // Kunden nach Kundennummer suchen
  static async searchKundenByNummer(kundenNummer: string): Promise<Kunde[]> {
    const response = await apiClient.get<Kunde[]>(`${this.ENDPOINT}/search`, {
      params: { kundenNummer }
    });
    return response.data;
  }
}
